import { Component } from '@angular/core';

@Component({
  selector: 'app-wrong-environment',
  templateUrl: './wrong-environment.component.html',
  styleUrls: ['./wrong-environment.component.scss']
})
export class WrongEnvironmentComponent {

  constructor() { }

}
